var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { class: [_vm.namespace(), _vm.skinStyle] }, [
    _vm.value >= 1 && _vm.value <= 9
      ? _c(
          "svg",
          {
            class: _vm.mdsNS("icon button__icon button_msbox"),
            attrs: {
              role: "img",
              "aria-label": _vm.styleBoxes[_vm.value].alt,
              alt: _vm.styleBoxes[_vm.value].alt
            }
          },
          [
            _c(
              "use",
              {
                attrs: {
                  "xlink:href": "#style-box-" + _vm.styleBoxes[_vm.value].style
                }
              },
              [_c("title", [_vm._v("Style Box")])]
            )
          ]
        )
      : _c("span", [_vm._v("—")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }